import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import PublicNav from "@/components/PublicNav";
import PublicFooter from "@/components/PublicFooter";
import usePageMeta from "@/hooks/usePageMeta";

export default function Blogs() {
  const [items, setItems] = useState([]);
  usePageMeta("Blog", "Guides, admission tips and school news from School Dial.");
  useEffect(() => { api.get("/blogs").then((r) => setItems(r.data)); }, []);
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <PublicNav />
      <div className="mx-auto max-w-7xl px-6 py-12 flex-1">
        <h1 className="text-4xl font-bold tracking-tight text-slate-900" data-testid="blogs-heading">Blog</h1>
        <p className="text-slate-500 mt-2">News, tips and guides for parents & educators</p>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mt-10">
          {items.length === 0 && <div className="text-slate-500 col-span-3">No blog posts yet.</div>}
          {items.map((b) => (
            <Link key={b.id} to={`/blogs/${b.slug}`} className="group" data-testid={`blog-card-${b.id}`}>
              <div className="aspect-[16/10] bg-slate-100 rounded overflow-hidden mb-4">
                {b.cover_image && (
                  <img
                    src={b.cover_image}
                    alt=""
                    onError={(e) => { e.currentTarget.style.display = "none"; }}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                )}
              </div>
              <div className="text-xs uppercase tracking-[0.2em] font-semibold text-amber-600">{(b.tags || []).join(" · ")}</div>
              <h3 className="text-xl font-bold text-slate-900 mt-2 group-hover:text-blue-700">{b.title}</h3>
              <p className="text-slate-500 mt-2 text-sm line-clamp-2">{b.excerpt}</p>
            </Link>
          ))}
        </div>
      </div>
      <PublicFooter />
    </div>
  );
}
